"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BaseModalsStack = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _modal = require("../../selectors/modal");
var _ModalsStack = _interopRequireDefault(require("../../components/ModalsStack"));
var _ModalsStack2 = _interopRequireDefault(require("../../components/ModalsStack/ModalsStack"));
var _excluded = ["modalsStackComponent"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var propTypes = {
  modalsStackComponent: _propTypes["default"].func
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    visibleModalsNames: (0, _modal.getVisibleModalsNames)(state)
  };
};
var ModalsStack = function ModalsStack(_ref) {
  var _ref$modalsStackCompo = _ref.modalsStackComponent,
    ModalsStackComponent = _ref$modalsStackCompo === void 0 ? _ModalsStack["default"] : _ref$modalsStackCompo,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ModalsStackComponent, rest);
};
ModalsStack.propTypes = propTypes;
var Modals = (0, _reactRedux.connect)(mapStateToProps)(ModalsStack);
var BaseModalsStack = exports.BaseModalsStack = (0, _reactRedux.connect)(mapStateToProps)(_ModalsStack2["default"]);
var _default = exports["default"] = Modals;